var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-secondary text-light deck-share",on:{"click":_vm.onShareDeck}},[_c('ShareIcon'),_vm._v(" Share\n\n  "),_c('DeckShareDialog',{ref:"deckShareDialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }